/**
 * 基础js方法的封装
 *
 */

function typeEqual(obj, type) {
	return Object.prototype.toString.call(obj) === '[object ' + type + ']';
}

export function isFn(obj) {
	return typeEqual(obj, 'Function');
};

export function isStr(obj) {
	return typeEqual(obj, 'String');
};

export function isObj(obj) {
	return typeEqual(obj, 'Object');
};

export function isArray(obj) {
	return typeEqual(obj, 'Array');
};

export function isUndefined(obj) {
	return typeEqual(obj, 'Undefined');
};

export function each(obj, fn, context) {
	if (!obj || !isFn(fn)) {
		return;
	}
	context = context || obj;

	if (isArray(obj)) {
		for (let i = 0, l = obj.length; i < l; i++) {
			if (fn.call(context, obj[i], i, obj) === false) {
				return;
			}
		}
	} else if (isObj(obj)) {
		for (let n in obj) {
			if (fn.call(context, obj[n], n, obj) === false) {
				return;
			}
		}
	}
};

const camelizeRE = /_(\w)/g;
export function camelize (str) {
	return str.replace(camelizeRE, toUpper);
}

function toUpper (_, c) {
	return c ? c.toUpperCase() : '';
}

export function noop() {

};



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/util/lang.js